// @flow
import { relationshipReducer } from "src/utils/reducerUtils";
import seriesSchema from "src/schemas/seriesSchema";

export const seriesRelationships = relationshipReducer({
  name: "series",
  relationshipSchemas: seriesSchema.relationshipSchemas
});
